<template lang="pug">
f-model.f-media(
  model='Media'
  collection='Media'
  :custom-label='customLabel'
  option-title='title'
  option-description='caption'
  v-bind=`$attrs`
  v-on='$listeners'
)
  template( #singleLabel='{ title }')
    .title( v-html=`title && title.rendered || ''` )
  template( #option='{ title, caption }')
    .title( v-html=`title && title.rendered || ''` )
    .description( v-html=`caption && caption.rendered || ''` )
</template>

<script lang="js">
import FModel from './f-model'
export default {
  name: 'MediaField',
  mixins: [],
  components: { FModel },
  props: {},
  data() {
    return {}
  },
  created() {},
  mounted() {},
  methods: {
    customLabel({ title, caption }) {
      return `${( title && title.rendered ) || '' }`
    },
  },
  computed: {}
}
</script>

<style lang="scss">
.f-media {

}
</style>
